<app-a-input [label]="trans.translate('Area/Pincode *')" [(variable)]="pincodeObject.pincode"
  (onType)="searchPincode($event)"></app-a-input>
<ion-card *ngIf="showPincodeOption1" class="scrollable margin0" style="height: 30vh;">
  <div *ngFor="let pin of filteredPinCode">
    <div class="padding5" (click)="setAddress(pin,'current_address')">{{pin}}</div>
    <div style="width: 100%; height:1px; background-color: black; color: black;"> </div>
  </div>
</ion-card>
<div>
  {{pincodeObject.current_address2}}
</div>